import styled from 'styled-components';
import { NumberInput } from '../../baseInputs/NumberInput';
import { useScene } from '../../../../context/sceneContext';

export const SizeInput = () => {
  const scene = useScene();

  const data = scene.getSelectedElementsData(
    {
      width: undefined,
      height: undefined,
    },
    'props.class'
  );

  const updateValue = (key: string, value?: string | number) =>
    scene.updateSelectedElementsData({ [key]: value }, 'props.class', 'sizeInput');

  return (
    <Row>
      <NumberInput
        label="W"
        value={data.width}
        onChange={(newValue) => updateValue('width', newValue)}
        precision={0}
        minValue={0}
        units={['px', '%']}
        defaultUnit="px"
      />
      <NumberInput
        label="H"
        value={data.height}
        onChange={(newValue) => updateValue('height', newValue)}
        precision={0}
        minValue={0}
        units={['px', '%']}
        defaultUnit="px"
      />
      <SideButtonContainer></SideButtonContainer>
    </Row>
  );
};

const Row = styled.div`
  width: 100%;
  display: flex;

  gap: 5px;
`;

const SideButtonContainer = styled.div`
  min-width: 60px;
  display: flex;
  justify-content: flex-end;
  gap: 5px;
`;
